import { api } from '../api.js';

/** config 可传 signal，供列表 AbortController 中断 */
export const getLandParcels = (params = {}, config = {}) => {
  return api.get('/land-parcels', { params, ...config });
};

export const getLandParcel = (id) => {
  return api.get(`/land-parcels/${id}`);
};

/** 地块逐日气象：params { startDate, endDate } 格式 YYYY-MM-DD，结束日期最晚为昨天 */
export const getLandWeatherDaily = (landId, params = {}) => {
  return api.get(`/land-parcels/${landId}/weather-daily`, { params });
};

export const getLandParcelSummary = (landParcelId, params = {}) => {
  return api.get(`/land-parcels/${landParcelId}/summary`, { params });
};

export const createLandParcel = (data) => {
  return api.post('/land-parcels', data);
};

export const updateLandParcel = (id, data) => {
  return api.put(`/land-parcels/${id}`, data);
};

export const deleteLandParcel = (id) => {
  return api.delete(`/land-parcels/${id}`);
};

export const mergeLandParcels = (data, params = {}) => {
  return api.post('/land-parcels/merge', data, { params });
};

export const splitLandParcel = (landParcelId, data = {}, params = {}) => {
  return api.post(`/land-parcels/${landParcelId}/split`, data, { params });
};
